import { css } from '@emotion/css'
import { colors } from 'settings/colors'

export const getErrorStyle = () => {
  return css({ borderColor: colors.red })
}
